// 语音转文字结果的 localStorage 缓存
// 同一条语音识别成功一次后持久保存，再次进入会话无需重复上传识别

// 单个 localStorage key 存所有记录，结构：{ [音频地址]: 转写文本 }
const VOICE_TEXT_CACHE_KEY = 'VOICE_TO_TEXT_CACHE'
// 最大缓存条数，超出后按最久未使用淘汰
const VOICE_TEXT_CACHE_MAX = 300

function readCache() {
  try {
    const cache = JSON.parse(localStorage.getItem(VOICE_TEXT_CACHE_KEY))
    return cache && typeof cache === 'object' ? cache : {}
  } catch (e) {
    // JSON 破损等脏数据直接丢弃重建
    return {}
  }
}

function writeCache(cache) {
  try {
    localStorage.setItem(VOICE_TEXT_CACHE_KEY, JSON.stringify(cache))
  } catch (e) {
    // 写入失败（如存储空间不足）时忽略，不影响识别主流程
  }
}

// 以音频地址作为缓存 key：去掉查询参数（签名/时间戳等跨会话会变），只留稳定路径
function normalizeKey(src) {
  return (src || '').split('?')[0]
}

// 读取缓存的转写文本，未命中返回 ''
export function getCachedVoiceText(src) {
  const key = normalizeKey(src)
  if (!key) return ''
  const cache = readCache()
  const text = cache[key]
  if (typeof text !== 'string') return ''
  // 命中后重写一次，把该条移到"最近使用"位置，避免被过早淘汰
  delete cache[key]
  cache[key] = text
  writeCache(cache)
  return text
}

// 写入转写文本，超出上限时从最旧的条目开始淘汰
export function setCachedVoiceText(src, text) {
  const key = normalizeKey(src)
  if (!key || !text) return
  const cache = readCache()
  delete cache[key]
  cache[key] = text
  const keys = Object.keys(cache)
  for (let i = 0; i < keys.length - VOICE_TEXT_CACHE_MAX; i += 1) {
    delete cache[keys[i]]
  }
  writeCache(cache)
}
